(function ($) {

  if($('.view-container').length > 0) {
    $('.view-container a').click(function(){
      $('.view-container a').toggleClass('active');
      $('.artists-view').toggleClass('active');
      $('.tiles .card').height('auto')    
    });
  }

  // artist filters

  $('.filter-toggle').click(function(){
    $('.filters').toggleClass('hide-for-small-only');
    $('.filters-cont.active').removeClass('active');
  });

  $('.artist-filter .artist-filter-header, .agent-filter .artist-filter-header').click(function(e){
    $('.filters-cont.active').not($(this).parent()).removeClass('active');
    $(this).parent().toggleClass('active');
    e.preventDefault();
  });
  
  $(document).click(function(event) { 
    var $target = $(event.target);
    if(!$target.closest('.filters-cont').length && !$target.hasClass('filter-toggle') &&  $('.filters-cont').is(":visible")) {
      $('.filters-cont.active').removeClass('active');
      $('.filters').addClass('hide-for-small-only');
    }       
  });


  if($('.artist-letter-filter').length > 0) {
    $('.artist-letter-filter a').click(function(e){
      let filter = $(this).data('filter');

      $('.filters-cont .active').removeClass('active');
      $(this).addClass('active');

      $('.artists-view .artist-filter').show();
      $('.artists-view.list .column').show();
      $('.artists-view .artist').show();
      $('.artists-view.list .post-list').removeClass('artist-filter');

      if (filter !== 'all') {
        $('.artists-view.list .post-list').addClass('artist-filter');
        $('.artists-view .artist-filter').hide();
        $('.artists-view .artist-filter.letter-filter-'+ filter).show();
      }

      e.preventDefault();
    });
  }

  // agent filters

  if($('.artist-agent-filter').length > 0) {
    $('.artist-agent-filter a').click(function(e){
      let filter = $(this).data('filter');

      $('.filters-cont .active').removeClass('active');
      $(this).addClass('active');

      $('.artists-view .artist').show();
      $('.artists-view.list .column').show();
      $('.artists-view .artist-filter').show();
      $('.artists-view.list .post-list').removeClass('artist-filter');

      if (filter !== 'all') {
        $('.artists-view .artist').hide();
        $('.artists-view .artist.agent-filter-'+ filter).show();

        $('.artists-view.list .column').each(function() {
          if ($(this).find('.artist:visible').length == 0) {
            $(this).hide();
          }
        });
      }

      window.location.hash = 'agent-' + filter;

      e.preventDefault();
    });
  }

  $(window).on('load',function(){
    let hash = window.location.hash;
    if (hash !== '') {
      hash = hash.substr(1);
    } 
    console.log(hash)
  });

  // gigs filters

  if($('.gigs-country-filter').length > 0) {
    $('.gigs-country-filter a').click(function(e){
      let filter = $(this).data('filter');

      console.log(filter)

      $('.filters-cont .active').removeClass('active');
      $(this).addClass('active');

      $('.gigs .gig').show();

      if (filter !== 'all') {
        $('.gigs .gig').hide();
        $('.gigs .gig.country-filter-'+ filter).show();
      }

      e.preventDefault();
    });
  }

})(jQuery);


// WEBPACK FOOTER //
// ./resources/assets/js/partial/filters.js